<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="园区/社区" prop="parkId">
                        <Select v-model="info.parkId" transfer>
                            <Option
                                v-for="item in parkList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.parkName }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="园区/社区类型">
                        <Input :value="parkType" placeholder disabled></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="详细地址">
                        <Input
                            :value="addr"
                            :maxlength="50"
                            placeholder
                            disabled
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="楼栋号" prop="floorName">
                        <Input
                            v-model="info.floorName"
                            placeholder
                            :allowDecimal="false"
                            :disabled="!isAdd"
                        >
                            <span slot="append">栋</span>
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="有无电梯" prop="hasLift">
                        <i-switch
                            v-model="info.hasLift"
                            size="large"
                            :true-value="1"
                            :false-value="0"
                        >
                            <span slot="open">有</span>
                            <span slot="close">无</span>
                        </i-switch>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="总楼层" prop="levelNum">
                        <input-number
                            v-model="info.levelNum"
                            placeholder
                            :allowDecimal="false"
                        >
                            <span slot="append">层</span>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="每层房间数" prop="houseNum">
                        <input-number
                            v-model="info.houseNum"
                            placeholder
                            :allowDecimal="false"
                        >
                            <span slot="append">间</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="排序">
                        <input-number
                            v-model="info.sortNum"
                            :allowDecimal="false"
                        />
                    </FormItem>
                </Col>
                <Col span="12" v-if="!id">
                    <FormItem label="添加整栋">
                        <i-switch
                            v-model="addRooms"
                            size="large"
                            :true-value="1"
                            :false-value="0"
                        />
                        <span style="color: #aaaaaa; margin-left: 10px"
                            >启用可批量添加房间</span
                        >
                    </FormItem>
                </Col>
            </Row>
            <div v-if="addRooms">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="建筑面积" prop="assetsHouse.buildArea">
                            <input-number
                                v-model="info.assetsHouse.buildArea"
                                placeholder
                                :min="0"
                                @on-blur="buildAreaChange(info.assetsHouse)"
                            >
                                <span slot="append">㎡</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="单价" prop="assetsHouse.unitPrice">
                            <input-number
                                v-model="info.assetsHouse.unitPrice"
                                placeholder
                                :min="0"
                                @on-blur="unitPriceChange(info.assetsHouse)"
                            >
                                <span slot="append">元/㎡/月</span>
                            </input-number>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="租金" prop="assetsHouse.rent">
                            <input-number
                                v-model="info.assetsHouse.rent"
                                placeholder
                                :min="0"
                                @on-blur="rentChange(info.assetsHouse)"
                            >
                                <span slot="append">元/月</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <!-- 单价区间 -->
                    <Col span="12">
                        <FormItem label="单价区间" prop="rentInterval">
                            <rent-interval
                                :info="info.assetsHouse"
                                @on-min-price-change="minPriceChange"
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="交租方式" prop="rentMode">
                            <rent-mode
                                spread-out
                                :value="rentMode"
                                @on-change="
                                    changeRentMode($event, info.assetsHouse)
                                "
                            />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="常规押金" prop="assetsHouse.deposit">
                            <input-number
                                v-model="info.assetsHouse.deposit"
                                placeholder
                            >
                                <span slot="append">元</span>
                            </input-number>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem prop="otherDeposit" label="其它押金">
                            <other-deposit :value="info.otherDeposit" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="wifi密码" prop="assetsHouse.wifiPwd">
                            <Input
                                v-model="info.assetsHouse.wifiPwd"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="装修格局" prop="assetsHouse.houseType">
                            <Input
                                v-model="info.assetsHouse.houseType"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            label="装修状态"
                            prop="assetsHouse.decorationType"
                        >
                            <Select
                                v-model="info.assetsHouse.decorationType"
                                transfer
                            >
                                <Option
                                    v-for="item in this.dict.decorationType.toList()"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.text }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="房间配置" prop="facilitys">
                            <room-config :value="info.facilitys" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem prop="otherFee" label="其它费用">
                            <other-fee :value="info.otherFee" />
                        </FormItem>
                    </Col>
                </Row>
            </div>
        </Form>
    </div>
</template>
<script>
import Dict from '_u/dict'
import mForm from '_v/common/m-form'
import { multiply } from '@/views/common/u-contract'

import {
    buildAreaChange,
    unitPriceChange,
    rentChange,
    changeRentMode,
} from '@/views/common/u-rent'

import {
    assetsFloorAdd,
    assetsFloorUpdate,
    assetsFloorView,
} from '@/api/assets'
import { assetsParkRootList } from '@/api/configuration'

import RentMode from '_vc/fields/rent-mode'
import RentInterval from '_vc/fields/rent-interval'
import RoomConfig from '_vc/fields/room-config'
import OtherFee from '_vc/fields/other-fee'
import OtherDeposit from '_vc/fields/other-deposit'
import { deepCopy } from 'ivux/src/utils/assist'

export default {
    name: 'floor-form',
    mixins: [mForm],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        parkId: {
            type: [String, Number],
            default: '',
        },
        floorInfoList: {
            type: Array,
            default() {
                return []
            },
        },
    },
    components: { RentMode, RoomConfig, RentInterval, OtherFee, OtherDeposit },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            info: {
                id: this.id,
                parkId: this.parkId, // 园区/社区
                floorName: '', //  楼栋号
                hasLift: 0, //有无电梯
                levelNum: '', //  总楼层
                houseNum: '', // 每层房间数
                sortNum: '', // 排序
                assetsHouse: {
                    buildArea: '', // 建筑面积
                    unitPrice: '', // 单价
                    minPrice: '', //(最低单价(分))
                    maxPrice: '', //(最高单价(分))
                    rent: '', // 租金
                    depositPayMethod: '', // 交租方式
                    rentPayMethod: '', // 交租方式
                    deposit: '', // 常规押金
                    houseType: '', // 户型
                    decorationType: '', // 装修状态
                    wifiPwd: '', // wifi密码
                },
                facilitys: [], // 房间配置
                otherFee: [], // 费用项
                otherDeposit: [], // 其他押金
                ver: '', // 版本号
                remark: '', //备注
            },
            parkList: [], // 园区列表
            dict: {
                parkType: Dict.NULL,
                decorationType: Dict.NULL,
            },
            addRooms: 0,
            rentMode: '',
            buildAreaChange: buildAreaChange,
            unitPriceChange: unitPriceChange,
            rentChange: rentChange,
            changeRentMode: changeRentMode,
        }
    },
    computed: {
        ruleValidate() {
            const validateLevelNum = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('总楼层必填'))
                } else if (this.id) {
                    // 编辑楼栋
                    // 当输入的值小于楼栋的楼层数，且楼层不能删除
                    value -= 0
                    if (
                        value < this.floorInfoList.length &&
                        !this.floorInfoList[value].flag
                    ) {
                        callback(
                            new Error('现有楼层房间存在被预定或出租，无法删除')
                        )
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            }

            const validateUnitPrice = (rule, value, callback) => {
                if (this.info.assetsHouse.unitPrice == 0) callback()

                if (
                    this.info.assetsHouse.unitPrice -
                        this.info.assetsHouse.minPrice >=
                    0
                )
                    callback()

                callback(new Error('单价不得低于最小值'))
            }

            let rules = {
                parkId: [{ required: true, message: '园区/社区必填' }],
                floorName: [{ required: true, message: '楼栋号必填' }],
                levelNum: [{ validator: validateLevelNum, trigger: 'blur' }],
                houseNum: [{ required: true, message: '每层房间数必填' }],
                levelNum: [{ required: true, message: '总楼层必填' }],
            }
            // 如果添加房间
            if (this.addRooms) {
                rules = {
                    parkId: [{ required: true, message: '园区/社区必填' }],
                    floorName: [{ required: true, message: '楼栋号必填' }],
                    levelNum: [
                        { validator: validateLevelNum, trigger: 'blur' },
                    ],
                    houseNum: [{ required: true, message: '每层房间数必填' }],
                    levelNum: [{ required: true, message: '总楼层必填' }],
                    'assetsHouse.unitPrice': [{ validator: validateUnitPrice }],
                }
            }
            console.log(rules)
            return rules
        },
        // 园区/社区类型
        parkType() {
            const park = this.parkList.find((v) => v.id === this.info.parkId)
            if (park) {
                const parkType = park.parkType
                return this.dict.parkType.get(parkType).text
            }
        },
        // 详细地址
        addr() {
            const park = this.parkList.find((v) => v.id === this.info.parkId)
            if (park) {
                return park.addr
            }
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return assetsFloorView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        // 最低价格更改，触发校验
        minPriceChange() {
            this.$refs.info.validate()
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            this.loading = true
            Promise.all([
                this.fetch(),
                assetsParkRootList(),
                Dict.get(['park_type', 'decoration_type']),
            ])
                .then((args) => {
                    var [view, park, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )

                        this.list = viewData.children
                    }

                    this.parkList = park.data.list
                })
                .finally(() => {
                    next()
                    this.loading = false
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    const formData = deepCopy(this.info)
                    if (this.addRooms) {
                        const house = formData.assetsHouse
                        house.unitPrice = multiply(house.unitPrice)
                        house.rent = multiply(house.rent)
                        house.deposit = multiply(house.deposit)
                        house.minPrice = multiply(house.minPrice)
                        house.maxPrice = multiply(house.maxPrice)

                        const data = this.$refs.info.populateData()

                        data.facilitys = data.facilitys || []
                        data.otherFee = data.otherFee || []
                        data.otherDeposit = data.otherDeposit || []
                        data.facilitys.forEach(
                            (v) => (v.price = multiply(v.price))
                        )
                        data.otherFee.forEach(
                            (v) => (v.amount = multiply(v.amount))
                        )
                        data.otherDeposit.forEach(
                            (v) => (v.amount = multiply(v.amount))
                        )

                        formData.assetsHouse = JSON.stringify(
                            formData.assetsHouse
                        )
                        formData.facilitys = JSON.stringify(data.facilitys)
                        formData.otherFee = JSON.stringify(data.otherFee)
                        formData.otherDeposit = JSON.stringify(
                            data.otherDeposit
                        )
                    } else {
                        formData.assetsHouse = ''
                        formData.facilitys = ''
                        formData.otherFee = ''
                        formData.otherDeposit = ''
                    }

                    if (this.id) {
                        return assetsFloorUpdate(formData)
                    } else {
                        return assetsFloorAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
